import { getAPIPath, requestGooseAPI } from '../shared/request'
import type { ClientInvoicesByPeriodSearchOptions, InvoiceClientDto } from '../types/api'
import { CLIENT_INVOICES_BY_PERIOD } from '../types/constants'

// The invoices-by-period spec takes repeated keys for list filters (invoiceSubStatus=A&invoiceSubStatus=B).
// Axios would send them as key[]=A&key[]=B, so arrays are serialized here. `includes` keeps its bracket form.
export const serializeInvoicesByPeriodParams = (params: Record<string, unknown>): string => {
  const search = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) return
    const items: unknown[] = Array.isArray(value) ? value : [value]
    const name = key === 'includes' ? 'includes[]' : key
    items.forEach((item) => search.append(name, String(item)))
  })
  return search.toString()
}

export const ClientInvoicesByPeriodService = {
  getData: (
    locationName: string,
    options: ClientInvoicesByPeriodSearchOptions
  ): Promise<{ results: InvoiceClientDto[]; nextToken: string | null }> => {
    const includesList = new Set(['location', 'period', 'locationServiceType.serviceType'])
    options.includes?.forEach((include) => includesList.add(include))
    return requestGooseAPI<{ results: InvoiceClientDto[]; nextToken: string | null }>({
      url: getAPIPath(CLIENT_INVOICES_BY_PERIOD, { locationId: locationName }),
      method: 'GET',
      params: {
        ...options,
        includes: [...includesList],
      },
      paramsSerializer: { serialize: serializeInvoicesByPeriodParams },
    })
  },
}
